var upperCase = require('upper-case')

/**
 * Upper case the first character of a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  if (str == null) {
    return ''
  }

  str = String(str)

  return upperCase(str.charAt(0), locale) + str.substr(1)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/upper-case-first/upper-case-first.js
 ** module id = 274
 ** module chunks = 1
 **/